<div *ngIf="isOffline" class="offline-banner w-80 mx-auto overflow-hidden">
    <div class="offline-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <!-- Outer Wi-Fi arc -->
            <path d="M1 10a16 16 0 0 1 22 0" />
            <!-- Inner Wi-Fi arc -->
            <path d="M4.93 13.93a10 10 0 0 1 14.14 0" />
            <!-- Wi-Fi dot -->
            <circle cx="12" cy="18" r="1" />
            <!-- “No” slash -->
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
        <div class="offline-text">
            <h2>{{ 'INTERNET' | translate}}</h2>
            <p>{{ 'CHECK_INTERNET' | translate}}</p>
        </div>
    </div>
</div>